import "../css/Home.css";

function Home() {
  return (
    <div className="home-wrapper">
      <div>Ex-Investment Banker</div>
      <div>FinTech</div>
      <div>Based in New York City</div>
    </div>
  );
}

export default Home;
